import { useEffect, useState } from 'react'

export const useStupidRefresh = () => {
  const [, setState] = useState(false)
  useEffect(() => {
    const id = setTimeout(() => setState(true), 100)
    return () => clearTimeout(id)
  }, [setState])
}
